export default {
    state: {
        isLoading: false,
        
        filter: {
            search: '',
            isActive: null,
            isAppointment: null,
            isNetrikaId: null,
            isOmsId: null,
            hasTypes: null
        }
    },
    mutations: {
        invertLoader(state) {
            return state.isLoading ? false : true
        },
        SET_FILTER_OPTIONS(state, payload) {
            for (let prop in payload) {
                state.filter[prop] = payload[prop]
            }
        },
        DROP_FILTER_OPTIONS(state) {
            state.filter = {
                search: '',
                isActive: null,
                isAppointment: null,
                isNetrikaId: null,
                isOmsId: null,
                hasTypes: null
            }
        }
    },
    actions: {
        invertLoader({ commit }) {
            commit('invertLoader')
        },

        SET_FILTER_OPTIONS({commit}, payload) {
            commit('SET_FILTER_OPTIONS', payload)
        },
        DROP_FILTER_OPTIONS({commit}) {
            commit('DROP_FILTER_OPTIONS')
        }
    },
    getters: {
        getLoaderStatus(state) {
            return state.isLoading
        },

        GET_FILTER_STATE(state) {
            return  state.filter
        }
    }
}